import { NavigateFunction } from 'react-router-dom';
import API_CONSTANT from '../../constants/APIConstant';
import { get, postJson, ApiResult } from '../apiClient';

export type SosStatus = 'ACTIVE' | 'ACKNOWLEDGED' | 'RESOLVED' | 'CANCELLED';
export type SosCategory = 'MEDICAL' | 'FIRE' | 'SECURITY' | 'OTHER';

export interface SosAlertDTO {
  id: number;
  societyId: number;
  residentName: string;
  homeLabel: string | null;
  mobile: string;
  category: SosCategory | null;
  status: SosStatus;
  raisedAt: string;
  acknowledgedAt: string | null;
  resolvedAt: string | null;
}

export interface RaiseSosResult {
  data: SosAlertDTO | null;
  /** True when the raise failed specifically because the society's subscription has expired (402). */
  expired: boolean;
}

export const raiseSosAPI = async (
  navigate: NavigateFunction, category?: SosCategory,
): Promise<RaiseSosResult> => {
  const res: ApiResult<SosAlertDTO> = await postJson<SosAlertDTO>(
    navigate, API_CONSTANT.PATH.SOS.RAISE, category ? { category } : {},
  );
  return { data: res.success && res.data ? res.data : null, expired: res.status === 402 };
};

export const setSosCategoryAPI = async (
  navigate: NavigateFunction, id: number, category: SosCategory,
): Promise<boolean> => {
  const res: ApiResult<unknown> = await postJson(navigate, API_CONSTANT.PATH.SOS.CATEGORY(id), { category });
  return res.success;
};

export const cancelSosAPI = async (navigate: NavigateFunction, id: number): Promise<boolean> => {
  const res: ApiResult<unknown> = await postJson(navigate, API_CONSTANT.PATH.SOS.CANCEL(id), {});
  return res.success;
};

export const getActiveSosAPI = async (navigate: NavigateFunction): Promise<SosAlertDTO[]> => {
  const res: ApiResult<SosAlertDTO[]> = await get<SosAlertDTO[]>(navigate, API_CONSTANT.PATH.SOS.ACTIVE);
  return res.success && Array.isArray(res.data) ? res.data : [];
};

/** The caller's own most recent SOS (any status), or null. */
export const getMySosAPI = async (navigate: NavigateFunction): Promise<SosAlertDTO | null> => {
  const res: ApiResult<SosAlertDTO> = await get<SosAlertDTO>(navigate, API_CONSTANT.PATH.SOS.MINE);
  return res.success && res.data ? res.data : null;
};

/** Guard-only: every SOS the society has raised, newest first. */
export const getSosHistoryAPI = async (navigate: NavigateFunction): Promise<SosAlertDTO[]> => {
  const res: ApiResult<SosAlertDTO[]> = await get<SosAlertDTO[]>(navigate, API_CONSTANT.PATH.SOS.HISTORY);
  return res.success && Array.isArray(res.data) ? res.data : [];
};

export const acknowledgeSosAPI = async (navigate: NavigateFunction, id: number): Promise<boolean> => {
  const res: ApiResult<unknown> = await postJson(navigate, API_CONSTANT.PATH.SOS.ACKNOWLEDGE(id), {});
  return res.success;
};

export const resolveSosAPI = async (navigate: NavigateFunction, id: number): Promise<boolean> => {
  const res: ApiResult<unknown> = await postJson(navigate, API_CONSTANT.PATH.SOS.RESOLVE(id), {});
  return res.success;
};
